import { render } from "./WTitle.vue?vue&type=template&id=8757b386&ts=true"
import script from "./WTitle.vue?vue&type=script&lang=ts"
export * from "./WTitle.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__